// extracted by mini-css-extract-plugin
export default {"wrapper":"links_wrapper__4T+Nh","link":"links_link__rS7yi","isActive":"links_isActive__us3z0","animeLeft":"links_animeLeft__PliP5","animeDown":"links_animeDown__etjM9"};